// A listino's lines marked against the listino before it (TD-083, Prices tab): a new "from" price, a line added or a
// line removed. A line is marked by its price alone, never by what it includes, and the split defaults live on the service line (TD-078).
import { ENTITY_CONFIG } from "@/core/entityConfig";
import type { Listino, ListinoLine } from "../types";
import { dateLabel } from "./format";

const clientWord = ENTITY_CONFIG.client.label.toLowerCase();

/** The delete confirm. The website falls back to the latest other listino already started, and has no prices without one. */
export function deleteListinoMessage(listino: Listino, listini: Listino[], today: string): string {
  const lead = `It ${listino.status === "scheduled" ? "starts" : "started"} ${dateLabel(listino.startDate)}. No ${clientWord}’s price changes`;
  const fallback = listini.some((l) => l.id !== listino.id && l.startDate <= today);
  return fallback
    ? `${lead}, and the website shows the latest listino started without it.`
    : `${lead}. The website then has no prices to show until another listino starts.`;
}

export interface ListinoRow {
  line: ListinoLine;
  prev?: ListinoLine;
  removed?: boolean;
}

/** The listino's lines, each with the previous listino's line for the same service line, then the lines it dropped. */
export function listinoRows(listino: Listino, previous: Listino | undefined): ListinoRow[] {
  const kept: ListinoRow[] = listino.lines.map((line) => ({ line, prev: previous?.lines.find((p) => p.serviceLineId === line.serviceLineId) }));
  const removed: ListinoRow[] = (previous?.lines ?? [])
    .filter((p) => !listino.lines.some((l) => l.serviceLineId === p.serviceLineId))
    .map((line) => ({ line, removed: true }));
  return kept.concat(removed);
}

export const isChanged = (r: ListinoRow) => !!r.removed || !r.prev || r.line.fromPriceMinor !== r.prev.fromPriceMinor;
